export default function cookie(store) {
  const { session } = store.getState();

  const options = 'path=/;domain=hardypress.com;secure';

  if (session.account) {
    document.cookie = `isSignedIn=true;${options}`;
  } else {
    document.cookie = `isSignedIn=;${options};expires=Thu, 01 Jan 1970 00:00:00 UTC`;
  }
}




// WEBPACK FOOTER //
// ./app/sideEffects/cookie.js